import { Model }    from '@mathquis/modelx';
import { computed } from 'mobx';

export default () => computed({ equals: (a: Model, b: Model) => a?.isLoaded === b?.isLoaded });